// extracted by css-extract-rspack-plugin
export default {"iframe":"L0aUL","hoverCardTrigger":"hCaZJ","inlineInfoIcon":"l8Sk8"};